import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SidebarService } from '../../@core/services/signals/sidebar.services';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: '../layouts.component.scss',
})
export class FooterComponent implements OnInit {
  isSidebarOpen$!: Observable<boolean>;
  currentYear: any;
  constructor() {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit(): void {

  }
  sidebarService = inject(SidebarService);
}
